/** Default landing path after login by system role / clinic role. */
export function homeForRole(role, user) {
  const r = (role || '').toLowerCase();
  const clinic = String(
    user?.clinic_role || user?.clinic_role_key || user?.role_key || '',
  ).toLowerCase();

  if (clinic === 'director' || clinic === 'dean_admin' || clinic === 'dean' || clinic === 'fic') {
    return '/management';
  }
  if (r === 'pharmacy' || r === 'pharmacist' || r === 'lab_technician') return '/pharmacy';
  if (r === 'purchase') return '/purchase';
  if (r === 'pharmacystores') return '/pharmacy-stores';
  if (r === 'storesadmin') return '/stores-admin';
  if (r === 'receptiondesk' || r === 'staff_nurse' || r === 'multi_skill_assistant') return '/reception/home';
  if (r === 'management' || r === 'fic') return '/management';
  if (r === 'patient') return '/patient';
  if (r === 'admin' || r === 'super_admin') return '/admin/overview';
  return '/dashboard';
}
